import styled from 'styled-components';
import { DarkGreySidely2, SurfaceColor } from '../../../styles/global/css/Utils';

export const Container = styled.div<{ height?: string, backgroundColor?: string, borderRadius?: string }>`
    background-color: ${p => p.backgroundColor ?? SurfaceColor};
    margin: 0;
    padding: 0;
    width: 100%;
    height: ${p => p.height ?? '75vh'};
    border-radius: ${p => p.borderRadius ?? '0'};
    font-family: "Inter", sans-serif;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
`;

export const Image = styled.img`
    display: block;
    width: 300px;
    height: 200px;
    padding: 10px;
    margin-left: auto;
    margin-right: auto;
`;

export const Text = styled.h5`
    color: ${DarkGreySidely2};
    text-align: center;
    margin: 20px;
    font-weight: normal;
    margin: 0;
`;
